import { Box, CircularProgress, Typography, SxProps } from "@mui/material";
import { CircularProgressProps } from "@mui/material/CircularProgress/CircularProgress";
import { Theme } from "@mui/system";

interface ILoaderProps {
  progressProps?: CircularProgressProps;
  show?: boolean;
  simple?: boolean;
  p?: number;
  sx?: SxProps<Theme>;
  text?: string;
}

export function Loader({
  progressProps = {},
  show = true,
  simple = false,
  p = 3,
  sx,
  text,
}: ILoaderProps) {
  const progress = <CircularProgress {...progressProps} />;
  const loader = simple ? (
    progress
  ) : (
    <Box
      className="loader"
      sx={{ display: "grid", placeItems: "center", p, ...sx }}
    >
      {progress}
      {text ? <Typography>{text}</Typography> : null}
    </Box>
  );

  return show ? loader : null;
}
